import dayjs from 'dayjs'

export default {
    install (Vue) {
        Vue.prototype.$date = dayjs
        // Vue.prototype.$date.prototype = dayjs.prototype
        Vue.prototype.$date.prototype.prettyDate = function (date) {
            date = dayjs(date)
            const diff = this.diff(date, 'day')
            if (!diff) {
                return this.format('hh:mm')
            } else if (diff === 1) {
                return `Ieri, ${this.format('hh:mm')}`
            } else {
                return this.format('DD-MM-YYYY hh:mm')
            }
        }
    }
}
